import { useQuery } from "@tanstack/react-query";
import { Link, NavLink } from "react-router-dom";
import { EyeOutlined, PlusOutlined } from "@ant-design/icons";
import { Button } from "@rumbledirect/ui";
import { Space } from "antd";
import { Table } from "@/components/v2";
import { fetchRootServicePartners } from "@/lib/api/resources/rootServicePartners";

export const RootServicepartnerList = () => {
  const query = useQuery({
    queryKey: ["root-service-partners"],
    queryFn: fetchRootServicePartners,
  });

  const dataSource = Array.isArray(query.data)
    ? query.data
    : (query.data?.member ?? []);

  const columns = [
    {
      title: "Naam",
      dataIndex: "name",
      key: "name",
      render: (_: unknown, record: { id: string; name: string }) => (
        <NavLink to={`/base/service-partners/${record.id}`}>
          {record.name}
        </NavLink>
      ),
    },
    { title: "Groep", dataIndex: "groupName", key: "groupName" },
    {
      title: "Externe referentie",
      dataIndex: "externalReference",
      key: "externalReference",
    },
    {
      title: "Audabox",
      dataIndex: "dwproAudaboxNumber",
      key: "dwproAudaboxNumber",
    },
    {
      title: "Acties",
      key: "actions",
      render: (_: unknown, record: { id: string }) => (
        <Link to={`/base/service-partners/${record.id}`}>
          <Button icon={<EyeOutlined />} variant="light" />
        </Link>
      ),
    },
  ];

  return (
    <div>
      <Space
        style={{ marginBottom: 16, width: "100%", justifyContent: "flex-end" }}
      >
        <Link to="/base/service-partners/create">
          <Button icon={<PlusOutlined />}>Nieuwe servicepartner</Button>
        </Link>
      </Space>
      <Table
        rowKey="id"
        dataSource={dataSource}
        columns={columns}
        loading={query.isLoading}
      />
    </div>
  );
};
